import React from 'react'
import styled from 'styled-components'

function SmallTitle({icon, title}) {
    return (
        <SmalTitleStyled>
            <p>{icon}</p>
            <h3>{title}</h3>
             
        </SmalTitleStyled>

    )
}

const SmalTitleStyled = styled.div`


`;


export default SmallTitle;

